import { useTranslation } from 'react-i18next';
import { loadLanguage } from '../i18n';

export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.startsWith('fr') ? 'fr' : 'en';

  return (
    <div
      className={`inline-flex items-center rounded-full bg-surface-container-high p-1 ${className}`}
      role="group"
      aria-label={t('common.language')}
    >
      <button
        type="button"
        onClick={() => loadLanguage('fr')}
        className={`px-3 py-1.5 rounded-full font-label-sm text-label-sm transition-colors ${
          current === 'fr'
            ? 'bg-primary text-on-primary'
            : 'text-on-surface-variant hover:text-on-surface'
        }`}
      >
        fr
      </button>
      <button
        type="button"
        onClick={() => loadLanguage('en')}
        className={`px-3 py-1.5 rounded-full font-label-sm text-label-sm transition-colors ${
          current === 'en'
            ? 'bg-primary text-on-primary'
            : 'text-on-surface-variant hover:text-on-surface'
        }`}
      >
        en
      </button>
    </div>
  );
}
